import React from 'react'

import MobileHeader from './MobileHeader'
import DesktopHeader from './DesktopHeader'

type Props = {
  headerAction?: React.ReactNode
  hideNavigation?: boolean
  transparentOnTop?: boolean
  highlightCartItems?: boolean
}

const Header = ({
  headerAction,
  hideNavigation = false,
  transparentOnTop = false,
  highlightCartItems = true
}: Props) => {
  return (
    <>
      <MobileHeader
        headerAction={headerAction}
        hideNavigation={hideNavigation}
        highlightCartItems={highlightCartItems}
      />
      <DesktopHeader
        headerAction={headerAction}
        hideNavigation={hideNavigation}
        highlightCartItems={highlightCartItems}
        transparentOnTop={transparentOnTop}
      />
    </>
  )
}

export default Header
